import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomButton } from 'components';
import { CaretRightIcon } from 'assets/icons';
import routesPath from 'routes/RoutesPath';
import EstimateCard from './EstimateCard'; // Assuming you have an EstimateCard component
import { useDispatch } from 'react-redux';
import { resetEstimateState } from 'containers/estimates/estimatesSlice'; // Updated import
import { EstimateForCustomer } from 'containers/customers/customers.model';
import { selectCurrentTeam, selectIsOwner } from 'containers/app/appSlice';
import { useAppSelector } from 'hooks';
import { SubscriptionStatus } from 'containers/app/app.model';

interface CustomerEstimatesWidgetProps {
  customerEstimatesList: EstimateForCustomer[];
  totalCustomerEstimatesCount: number;
  customerId: string;
}

const CustomerEstimatesWidget: React.FC<CustomerEstimatesWidgetProps> = ({
  customerEstimatesList,
  totalCustomerEstimatesCount,
  customerId
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const currentTeam = useAppSelector(selectCurrentTeam);
  const isOwner = useAppSelector(selectIsOwner);

  const handleEstimatesNavigation = () => {
    const estimatesRouteState = {
      customerId
    };
    navigate(routesPath.ESTIMATES, { replace: false, state: estimatesRouteState });
  };

  const handleCreateEstimate = () => {
    if (
      currentTeam?.subscriptionStatus === SubscriptionStatus.SUBSCRIPTION_EXPIRED ||
      currentTeam?.subscriptionStatus === SubscriptionStatus.NOT_SUBSCRIBED
    ) {
      if (isOwner) navigate(routesPath.ESTIMATE_INTEGRATION);
      else navigate(routesPath.ESTIMATES);
      return;
    }
    dispatch(resetEstimateState());
    navigate('/estimates/create?customerId=' + customerId);
  };

  return (
    <div className="mx-4 rounded-md border border-border">
      <div
        className="flex justify-between border-b border-borderGray
        px-4 py-3 text-sbase leading-[18px] tracking-[-0.3px]">
        <div className="font-bold text-primaryText">Estimates</div>
        {totalCustomerEstimatesCount > 0 ? (
          <button className="font-semibold text-secondary" onClick={handleEstimatesNavigation}>
            See all
          </button>
        ) : (
          <></>
        )}
      </div>
      {customerEstimatesList?.length > 0 ? (
        <div className="flex flex-col gap-4 border-b border-borderGray p-4">
          {customerEstimatesList.map((estimate, index) => (
            <EstimateCard estimate={estimate} key={index} />
          ))}
          <button
            className="flex justify-between text-sbase font-semibold
           leading-[18px] tracking-[-0.3px] text-secondary"
            onClick={handleEstimatesNavigation}>
            View all estimates
            <CaretRightIcon className="path-fill-current text-gray-1" />
          </button>
        </div>
      ) : (
        <></>
      )}
      <div className="p-4">
        <CustomButton
          id="customer-details-create-estimate"
          className="h-10 w-full"
          childrenContainerStyles="text-17px font-semibold"
          onClick={handleCreateEstimate}>
          Create estimate
        </CustomButton>
      </div>
    </div>
  );
};

export default CustomerEstimatesWidget;
